const CLOUDINARY_BASE = "https://res.cloudinary.com/dpk0ydobt/image/upload/q_auto,f_auto/placof/";

export const servicesData = [
  {
    id: 1,
    title: "Décoration Intérieure",
    description: "Transformez vos espaces intérieurs avec nos solutions personnalisées",
    icon: "home",
    image: `${CLOUDINARY_BASE}services/dec-int.jpeg`
  },
  {
    id: 2,
    title: "Aménagement Extérieur",
    description: "Créons ensemble des espaces extérieurs harmonieux et fonctionnels",
    icon: "tree",
    image: `${CLOUDINARY_BASE}services/amenag-ext.avif`
  },
  {
    id: 3,
    title: "Design Commercial",
    description: "Solutions professionnelles pour restaurants, bureaux et commerces",
    icon: "building",
    image: `${CLOUDINARY_BASE}services/commerce.avif`
  },
  {
    id: 4,
    title: "Consultation Design",
    description: "Conseils d'experts pour optimiser vos projets de décoration",
    icon: "lightbulb",
    image: `${CLOUDINARY_BASE}services/consult-design.avif`
  },
  {
    id: 5,
    title: "Mobilier Sur Mesure",
    description: "Création de mobilier unique adapté à vos besoins spécifiques",
    icon: "couch",
    image: `${CLOUDINARY_BASE}services/mob-sur-mesure.jpeg`
  },
  {
    id: 6,
    title: "Éclairage Design",
    description: "Solutions d'éclairage modernes pour sublimer vos espaces",
    icon: "sun",
    image: `${CLOUDINARY_BASE}services/eclairage.jpeg`
  }
];

export const projectsData = [
  {
    id: 1,
    image: `${CLOUDINARY_BASE}projets-gen/villa.jpeg`,
  },
  {
    id: 2,
    image: `${CLOUDINARY_BASE}projets-gen/rest.jpeg`,
  },
  {
    id: 3,
    image: `${CLOUDINARY_BASE}projets-gen/int.jpeg`,
  },
  {
    id: 4,
    image: `${CLOUDINARY_BASE}projets-gen/comm-1.jpeg`,
  },
  {
    id: 5,
    image: `${CLOUDINARY_BASE}projets-gen/comm-2.jpeg`,
  },
  {
    id: 6,
    image: `${CLOUDINARY_BASE}projets-gen/int-1.jpeg`,
  },
  {
    id: 7,
    image: `${CLOUDINARY_BASE}projets-gen/int-2.jpeg`,
  },
  {
    id: 8,
    image: `${CLOUDINARY_BASE}projets-gen/int-3.jpeg`,
  },
  {
    id: 9,
    image: `${CLOUDINARY_BASE}projets-gen/int-4.jpeg`,
  },
];
